export const useFormRules = () => {
  const required = (v: string | number | boolean) => !!v || "此欄位為必填";
  const requiredEng = (v: string | number | boolean) => !!v || "This field is required.";

  const numberRangeRules = (v: string, min: number, max: number) => {
    return !!v == false || (parseInt(v) >= min && parseInt(v) <= max) || `請輸入${min}至${max}之間的金額`;
  };

  const numberRangeEngRules = (v: string, min: number, max: number) => {
    return (
      !!v == false || (parseInt(v) >= min && parseInt(v) <= max) || `Please enter an amount between ${min} and ${max}`
    );
  };

  const maxLength = (v: string, max: number) => v.length <= max || `請輸入${max}個字以內`;
  const maxLengthEng = (v: string, max: number) => v.length <= max || `Please enter within ${max} characters`;

  const IdRules = (v: string) => {
    if (!!v == false) return true;
    v = !!v == true ? v.trim().toUpperCase() : "";
    const msg = "不正確的身分證格式";
    const verification = v.match("^[A-Z][128AC9BD]\\d{8}$");
    if (!verification) return msg;

    const conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO";
    const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

    v = String(conver.indexOf(v[0]) + 10) + v.slice(1);

    let checkSum = 0;
    for (let i = 0; i < v.length; i++) {
      let x = v[i];
      if (i == 2)
        x = v[i] == "A" || v[i] == "C" || v[i] == "B" || v[i] == "D" ? String(conver.indexOf(v[i]) + 10)[0] : v[i];

      let c = parseInt(x);
      let w = weights[i];
      checkSum += c * w;
    }
    return !!v == false || checkSum % 10 == 0 || msg;
  };

  const emailRules = (v: string) => {
    const emailRegxp = /[\w-]+@([\w-]+\.)+[\w-]+/;
    return !!v == false || emailRegxp.test(v) || "不正確的email格式";
  };

  const emailEngRules = (v: string) => {
    const emailRegxp = /[\w-]+@([\w-]+\.)+[\w-]+/;
    return !!v == false || emailRegxp.test(v) || "Incorrect email format";
  };

  return {
    required,
    requiredEng,
    numberRangeRules,
    numberRangeEngRules,
    IdRules,
    emailRules,
    emailEngRules,
    maxLength,
    maxLengthEng,
  };
};
